import { useTranslation } from "react-i18next"
import placeHolderImg3 from "../src/assets/placeHolderImg3.png"
import placeHolderAvatar from "../src/assets/user.png"

const StatisticsKeys = () => {
    const { t } = useTranslation()
    return {
        played: "لعب",
        win: "فوز",
        lose: "خساره",
        draw: "تعادل",
        goals_in: "عليه",
        goals_out: "اهداف له",
        goals_penalty: "اهداف الجزاء",
        clean_sheet: "شباك نظيفه",
        yellow_cards: "كروت صفراء",
        red_cards: "كروت حمراء",
        difference: "فارق الاهداف",
        point: "نقاط",
        passes: "تمريرات ناجحه",
        lost_balls: "كرات ضائعه",
        attempts: "محاولات على المرمى",
        chances: "فرص",
        dribbles: "المراوغات",
        fouls_in: "اخطاء عليه",
        fouls_out: "اخطاء له",
        ball_win: "استعاد الكرة",
        ball_lose: "خسر الكرة",
        appearance: "لعب",
        missed_penalty: "اضاع بنلتي",
        played_minutes: "دقائق اللعب",
        assists: "صانع اهداف",
        reversed_goals: "هدف في مرماه",
        goals: "اهداف"
    }
}
const IDS = {
    SERVICES: {
        PUBLIC: null,
        LOCAL: 7,
        INTERNATIONAL: 8,
        AFRICA: 9,
        OTHERSPORTS: 10,
    },
    SPORTS: {
        FOOTBALL: 1,
        TENNIS: 2,
        BASCKETBALL: 3,
        HOCKEY: 4,
        VOLLEYBALL: 5,
        HANDBALL: 6,
        SQUASH: 7,
        SWIMMING: 8,
    },
    SECTIONS: {
        FL3AGLAELSALAMA: 4,
        ROADTOCHAMPIONSHIP: 10,
        FUN2FIT: 7,
        ADELSAAD: 9,
        AFRICASTORIES: 8,
    },
    PORTALS: {
        NEW_ET: 1,
        TWIST: 3,
    }
}

const ImgURL = (src, isPlayer) => {
    if (src === null || src === undefined) {
        return isPlayer ? placeHolderAvatar : placeHolderImg3
    }

    if (src?.startsWith("http")) {
        return src;
    } else {
        return process.env.REACT_APP_NEW_MEDIA_URL + src
    }
}


const changeStructure = (oldS) => {
    const newS = oldS;
    newS.manager_name = oldS.player_one
    newS.manager_name = oldS.player_one
    return newS
}

const globalBaseUrl = {
    current: process.env.REACT_APP_PERFORMANCE_BASE_URL
}

export { StatisticsKeys, IDS, ImgURL, changeStructure, globalBaseUrl };